import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  DONATOR_LIST,
  DONATOR_ADDEDIT,
  DONATOR_CHANGE_STATUS,
  DONATOR_DELETE,
  DONATOR_EXPORT,
} from "../../api/constApi";
import {
  donatorsListApi,
  donatorsChangeStatusApi,
  AddEditDonatorsApi,
  donatorDeleteApi,
  donatorExportApi,
} from "../Services/DonatorService";

export const donatorsList = createAsyncThunk(DONATOR_LIST, async (payload) => {
  const response = await donatorsListApi(payload);
  return response.data;
});

export const donatorsChangeStatus = createAsyncThunk(
  DONATOR_CHANGE_STATUS,
  async (payload) => {
    const response = await donatorsChangeStatusApi(payload);
    return response.data;
  },
);

export const addEditdonators = createAsyncThunk(
  DONATOR_ADDEDIT,
  async (payload) => {
    const response = await AddEditDonatorsApi(payload);
    return response.data;
  },
);

export const donatorsDelete = createAsyncThunk(
  DONATOR_DELETE,
  async (payload) => {
    const response = await donatorDeleteApi(payload);
    return response.data;
  },
);

export const donatorExport = createAsyncThunk(
  DONATOR_EXPORT,
  async (payload) => {
    const response = await donatorExportApi(payload);
    return response.data;
  },
);

// export const fundsWopList = createAsyncThunk(FUND_WOP_LIST, async (payload) => {
//     const response = await fundWopListApi(payload);
//     return response.data;
// });

export const donatorsSlice = createSlice({
  name: "donators",
  initialState: {
    donators: null,
    // districtWop: null,
    token: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(donatorsList.fulfilled, (state, action) => {
      state.donators = action?.payload;
    });
    builder.addCase(addEditdonators.fulfilled, (state, action) => {
      state.donators = action?.payload?.Data;
    });
  },
});

export default donatorsSlice.reducer;
